/**
 * @generated SignedSource<<c5a04f61f8cf49b9a2c42979deb317e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedTrackingContainer_user$data = {
  readonly __typename: "User";
  readonly " $fragmentType": "SharedTrackingContainer_user";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "SharedTrackingContainer_user";
};
export type SharedTrackingContainer_user$key = {
  readonly " $data"?: SharedTrackingContainer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedTrackingContainer_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedTrackingContainer_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "a3998c0eb3bebcfd5d0c71b3af919c3f";

export default node;
